import { HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export const productId = 'SS1VUF9VUC0yOA==';
export class AccidentSettings extends BuyInsuranceSettings {
	public work: Array<string> = [];
	public workIds: Array<string> = [];
	public seniorStep1 = 66;
	public seniorStep2 = 75;
	public maxCustomerAge = 74;
	public customerMaxAgePopupTitle: string = undefined;
	public customerMaxAgePopupContent: string = undefined;
	public customerMaxAgePopupRedirect: string = undefined;

	public customerOtherMaxAgePopupTitle: string = undefined;
	public customerOtherMaxAgePopupContent: string = undefined;
	public customerOtherMaxAgePopupRedirect: string = undefined;

	public customerOtherAgePopupTitle: string = undefined;
	public customerOtherAgePopupContent: string = undefined;
	public customerOtherAgePopupRedirect: string = undefined;
	// HACK - Around june every year, the calculator fails on 18 years and 66 years, because the API interprets the age for certain coverages faulty
	public hackAgeForApi = 0;

	public constructor(settingsBlock: HtmlBlock) {
		super(settingsBlock);
		this.loadAccidentSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadAccidentSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.startsWith('work=')) {
					this.work = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('workids=')) {
					this.workIds = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('seniorstep1=')) {
					this.seniorStep1 = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('seniorstep2=')) {
					this.seniorStep2 = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('maxcustomerage=')) {
					this.maxCustomerAge = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('customermaxagepopuptitle=')) {
					this.customerMaxAgePopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customermaxagepopupcontent=')) {
					this.customerMaxAgePopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customermaxagepopupredirect=')) {
					this.customerMaxAgePopupRedirect = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerothermaxagepopuptitle=')) {
					this.customerOtherMaxAgePopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerothermaxagepopupcontent=')) {
					this.customerOtherMaxAgePopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerothermaxagepopupredirect=')) {
					this.customerOtherMaxAgePopupRedirect = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerotheragepopuptitle=')) {
					this.customerOtherAgePopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerotheragepopupcontent=')) {
					this.customerOtherAgePopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customerotheragepopupredirect=')) {
					this.customerOtherAgePopupRedirect = this.getSettingsValue(setting_);
				} else if (setting.startsWith('hackageforapi=')) {
					this.hackAgeForApi = Number.parseInt(this.getSettingsValue(setting_));
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
